
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c67"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c67"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aMV6p", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $7daaae658e780960$export$6503ec6e8aabbaf; }, function (v) { return $7daaae658e780960$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $7daaae658e780960$export$f7ad0328861e2f03; }, function (v) { return $7daaae658e780960$export$f7ad0328861e2f03 = v; });
var $7daaae658e780960$export$6503ec6e8aabbaf;
var $7daaae658e780960$export$f7ad0328861e2f03;
"use strict";
var $7daaae658e780960$var$mapping = new Map();
function $7daaae658e780960$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$7daaae658e780960$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $7daaae658e780960$var$resolve(id) {
    var resolved = $7daaae658e780960$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$7daaae658e780960$export$6503ec6e8aabbaf = $7daaae658e780960$var$register;
$7daaae658e780960$export$f7ad0328861e2f03 = $7daaae658e780960$var$resolve;

});

parcelRegister("g7uqX", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $bbc4e84816e3df56$export$bdfd709ae4826697; }, function (v) { return $bbc4e84816e3df56$export$bdfd709ae4826697 = v; });
var $bbc4e84816e3df56$export$bdfd709ae4826697;
var $bbc4e84816e3df56$export$c9e73fbda7da57b6;
var $bbc4e84816e3df56$export$5a759dc7a1cfb72a;
"use strict";
var $bbc4e84816e3df56$var$bundleURL = {};
function $bbc4e84816e3df56$var$getBundleURLCached(id) {
    var value = $bbc4e84816e3df56$var$bundleURL[id];
    if (!value) {
        value = $bbc4e84816e3df56$var$getBundleURL();
        $bbc4e84816e3df56$var$bundleURL[id] = value;
    }
    return value;
}
function $bbc4e84816e3df56$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $bbc4e84816e3df56$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $bbc4e84816e3df56$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $bbc4e84816e3df56$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$bbc4e84816e3df56$export$bdfd709ae4826697 = $bbc4e84816e3df56$var$getBundleURLCached;
$bbc4e84816e3df56$export$c9e73fbda7da57b6 = $bbc4e84816e3df56$var$getBaseURL;
$bbc4e84816e3df56$export$5a759dc7a1cfb72a = $bbc4e84816e3df56$var$getOrigin;

});

var $629d025a4b285614$exports = {};


(parcelRequire("aMV6p")).register((parcelRequire("g7uqX")).getBundleURL("hkxlb"), JSON.parse('["hkxlb","index.aef4ea44.js","aixVb","sw.js","llIC4","application.beb01e87.js","k0f1V","bg.42ce76ab.jpg","8EqrY","ADMIN.c5426ae8.jpg","crumx","APP.768063a7.jpg","3sTmT","EVENTS.fc055251.jpg","6GQNO","HEROES.f6aceb76.jpg","5KMQo","PARENTS.dcc3a2e9.jpg","dWOcy","PLAY.206b9901.jpg","2zoLn","PROMISE.c0103f72.jpg","d4QS8","RULES.ecdcc89b.jpg","e3Dh6","application.7a3fb986.js","7rfXR","application.072e327e.css","jqDPe","batman.5b8e1050.png","oNBPu","black_panther.cb848b80.png","dXSUy","flash.5ac9a66c.png","cE7xn","hulk.14e8509b.png","8XAgh","iron_man.97c262be.png","e6g5G","spiderman.e2295677.png","1UEJN","wolverine.6acf5939.png","9WNbP","batwoman.34080648.png","5Nl78","black_widow.803b452f.png","i0ub7","captain_marvel.a971ec72.png","85rJe","she-hulk.2acf9bfa.png","3Z4kV","spidergwen.662a1233.png","GFmHd","storm.f2f1255d.png","4NIeP","login.365d797c.js","crhjE","recovery.6c6351ab.js","iARrK","signup.2dc1805c.js","7YzF3","household.444a60eb.js"]'));


//# sourceMappingURL=index.runtime.23683e6c.js.map
